import React, { useRef, useState } from "react";
import { Modal, message } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

import NewAppForm from "./NewAppForm";
import Axios from "../../../util/request";

function NewAppModal(props) {
  const [loading, setLoading] = useState(false);
  const { visible, onCancel, onCreate } = props;
  const FormRef = useRef(null);
  const Intl = useIntl();
  const handleSubmit = () => {
    FormRef.current.validateFieldsAndScroll((err, values) => {
      if (!err) {
        setLoading(true);
        Axios.post("/api/v1/oauthapp", values)
          .then(res => {
            onCreate(res.data);
            FormRef.current.resetFields();
          })
          .catch(err => {
            message.error(Intl.formatMessage({ id: "message_createFailed" }));
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };
  return (
    <Modal
      visible={visible}
      title={<FormattedMessage id="newApp_title" />}
      onCancel={onCancel}
      okText={<FormattedMessage id="newApp_add" />}
      onOk={() => handleSubmit()}
      okButtonProps={{ type: "primary", loading: loading }}
      mask={false}
    >
      <NewAppForm ref={FormRef} />
    </Modal>
  );
}

export default NewAppModal;
